import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function WhyFailedSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-surface)'
  }} data-id="element-329">
      <div className="max-w-2xl mx-auto" data-id="element-330">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="mb-10" data-id="element-331">
          <p className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
          color: 'var(--color-accent)'
        }} data-id="element-332">
            Por qué todo lo anterior falló
          </p>

          <h2 className="text-3xl md:text-4xl font-black mb-8 leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-333">
            Seamos honestos sobre la industria.
          </h2>

          <div className="py-6 px-8 mb-10 rounded-sm" style={{
          background: '#0f0f0f',
          borderLeft: '4px solid var(--color-accent)'
        }} data-id="element-334">
            <p className="text-xl italic leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-text)'
          }} data-id="element-335">
              "La industria del crecimiento personal está construida sobre un
              modelo de negocio brillante: darte suficiente para sentirte
              inspirado. Pero no suficiente para que no necesites volver."
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.3,
        duration: 0.7
      }} className="space-y-4 mb-10" data-id="element-336">
          <div className="flex items-center gap-4" data-id="element-337">
            <XIcon className="w-5 h-5 flex-shrink-0" style={{
            color: '#ef4444'
          }} data-id="element-338" />
            <p className="text-lg" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-339">
              Los cursos te dan{' '}
              <strong style={{
              color: 'var(--color-text)'
            }} data-id="element-340">
                estrategias.
              </strong>
            </p>
          </div>
          <div className="flex items-center gap-4" data-id="element-341">
            <XIcon className="w-5 h-5 flex-shrink-0" style={{
            color: '#ef4444'
          }} data-id="element-342" />
            <p className="text-lg" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-343">
              Los libros te dan{' '}
              <strong style={{
              color: 'var(--color-text)'
            }} data-id="element-344">
                conceptos.
              </strong>
            </p>
          </div>
          <div className="flex items-center gap-4" data-id="element-345">
            <XIcon className="w-5 h-5 flex-shrink-0" style={{
            color: '#ef4444'
          }} data-id="element-346" />
            <p className="text-lg" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-347">
              Los coaches te dan{' '}
              <strong style={{
              color: 'var(--color-text)'
            }} data-id="element-348">
                marcos de referencia.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.5,
        duration: 0.7
      }} data-id="element-349">
          <p className="text-xl font-bold mb-8" style={{
          color: 'var(--color-text)'
        }} data-id="element-350">
            Pero nadie entra donde realmente vive el problema.
          </p>

          <div className="p-8 rounded-sm mb-10" style={{
          background: '#0f0f0f',
          border: '1px solid var(--color-border)'
        }} data-id="element-351">
            <p className="text-lg mb-3" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-352">
              <strong style={{
              color: 'var(--color-text)'
            }} data-id="element-353">
                El problema no está en tu agenda.
              </strong>
            </p>
            <p className="text-lg mb-3" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-354">
              <strong style={{
              color: 'var(--color-text)'
            }} data-id="element-355">
                No está en tu rutina matutina.
              </strong>
            </p>
            <p className="text-lg" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-356">
              <strong style={{
              color: 'var(--color-text)'
            }} data-id="element-357">
                No está en tus hábitos.
              </strong>
            </p>
          </div>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-358">
            El problema está en la programación subconsciente que activa el
            sabotaje automático cada vez que te acercas demasiado a lo que
            quieres.
          </p>

          <p className="text-lg leading-relaxed" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-359">
            Y esa programación no cambia con más información. Cambia con{' '}
            <strong style={{
            color: 'var(--color-accent)'
          }} data-id="element-360">
              repetición estratégica, exposición constante y formatos diseñados
              para penetrar debajo del pensamiento consciente.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}